import React from 'react'

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import FieldProto from "../../../fields3/proto/field-proto"

type Props = {
    className?      : string

    field           : FieldProto
    description?    : string
}

export default function HelpButtonField(props:Props) {

    if (!props.description && !props.field.description) return null

    const classes = Classes("ui5-ico-help v2", props.className, {})

    return (
        <div className={classes}>
            <HintPopover hint={props.description || props.field.description} multiline={true}/>
        </div>
    )
}